import { ReactElement } from 'react';

import './styles.scss';

export interface IProps {
  className?: string;
  color?: string;
}

export const DEFAULT_SPINNER_COLOR = '#0bc1e6';

const Spinner = ({
  className = '',
  color = DEFAULT_SPINNER_COLOR
}: IProps): ReactElement => {
  return (
    <div className={`spinner ${className}`}>
      <svg className="spinner-icon" viewBox="0 0 32 32">
        <circle
          cx="16"
          cy="16"
          fill="none"
          r="14"
          strokeWidth="3"
          stroke={color}
          opacity={0.6}
        />
        <circle
          cx="16"
          cy="16"
          fill="none"
          r="14"
          strokeWidth="3"
          stroke={color}
          strokeDasharray={80}
          strokeDashoffset={60}
        />
      </svg>
    </div>
  );
};

export default Spinner;
